// Angular Imports
import { ToolModule } from '../tool/tool.module';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { NgModule } from '@angular/core';

// This Module's Components
import { DemoComponent } from './demo.component';
import { MaintenanceModule } from '@app/maintenance/maintenance.module';
import { StrainCommonModule } from '@app/strain/common/strain-common.module';
import { ComponentStateComponent } from './components/component-state/component-state.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TranslateModule,
        SharedModule,
        ToolModule,
        MaintenanceModule,
        StrainCommonModule
    ],
    declarations: [
        DemoComponent,
        ComponentStateComponent,
    ],
    exports: [
        DemoComponent,
    ]
})
export class DemoModule {

}
